import { apiCall, apiCallAdmin } from "../../../services/api-service.js";

export const getLocationApi = async (term) => {
    const response = await apiCallAdmin("GET", `get_location?term=${term}`);
    return response;
};

export const getDeptApi = async (term) => {
    const response = await apiCallAdmin("GET", `get_department?term=${term}`);
    return response;
};

export const getCustApi = async (term) => {
    const response = await apiCallAdmin("GET", `get_customer?term=${term}`);
    return response;
};

export const getVendApi = async (term) => {
    const response = await apiCallAdmin("GET", `get_vendor?term=${term}`);
    return response;
};

export const getProductApi = async (term) => {
    const response = await apiCall("GET", `get_product${term}`);
    return response;
};

export const getProductTypeSuggApi = async (term) => {
    const response = await apiCall("GET", `get_product_type?term=${term ?? ""}`);
    return response;
};

export const getProductTypeApi = async (exclude_id, term) => {
    const response = await apiCall(
        "GET",
        `get_product_type?exclude_id=${exclude_id}&term=${term ?? ""}`
    );
    return response;
};

export const getCustomerListApi = async (params) => {
    const response = await apiCall("GET", `customer?${params}`);
    return response;
};

export const saveCustomerApi = async (body) => {
    const response = await apiCall("POST", "customer", body);
    return response;
};

export const updateCustomerApi = async (body, id) => {
    const response = await apiCall("PUT", `customer/${id}`, body);
    return response;
};

export const getCustomerApi = async (id) => {
    const response = await apiCall("GET", `customer/${id}`);
    return response;
};

export const getCustomerSugApi = async (term) => {
    const response = await apiCall("GET", `get_customer?term=${term ?? ""}`);
    return response;
};

export const getTransporterListApi = async (params) => {
    const response = await apiCall("GET", `transporter?${params}`);
    return response;
};

export const getProductListApi = async (params) => {
    const response = await apiCall("GET", `product_type?${params}`);
    return response;
};

export const getautoTriggerListApi = async (params) => {
    const response = await apiCallAdmin("GET", `auto_mail_trigger?${params}`);
    return response;
};

export const saveTransporterApi = async (body) => {
    const response = await apiCall("POST", "transporter", body);
    return response;
};

export const saveProductApi = async (body) => {
    const response = await apiCall("POST", "product_type", body);
    return response;
};

export const updateTransporterApi = async (body, id) => {
     const response = await apiCall("PUT", `transporter/${id}`, body);
    return response;
};

export const updateProductApi = async (body, id) => {
    const response = await apiCall("PUT", `product_type/${id}`, body);
    return response;
};

export const getTransporterApi = async (id) => {
    const response = await apiCall("GET", `transporter/${id}`);
    return response;
};

export const getProductTypesApi = async (id) => {
    const response = await apiCall("GET", `product_type/${id}`);
    return response;
};

export const getVendorListApi = async (params) => {
    const response = await apiCall("GET", `vendor?${params}`);
    return response;
};

export const saveVendorApi = async (body) => {
    const response = await apiCall("POST", "vendor", body);
    return response;
};

export const updateVendorApi = async (body, id) => {
    const response = await apiCall("PUT", `vendor/${id}`, body);
    return response;
};

export const getVendorApi = async (id) => {
    const response = await apiCall("GET", `vendor/${id}`);
    return response;
};

export const getVendorSugApi = async (term) => {
    const response = await apiCall("GET", `get_vendor?term=${term ?? ""}`);
    return response;
};
